import clsx from "clsx";
import React, { FC, MouseEventHandler } from "react";

import { Icon, IconName } from "../../../icon";
import { Spinner } from "../../../spinner";

export interface TextInputDecorationProps {
  type: "spinner" | "search" | "chevron-down" | "clear" | IconName;
  onClickClear?: MouseEventHandler;
  onClickChevronDown?: MouseEventHandler;
  onClickIcon?: MouseEventHandler<SVGSVGElement>;
  disabled?: boolean;
}

export const TextInputDecoration: FC<TextInputDecorationProps> = ({
  type,
  onClickClear,
  onClickIcon,
  onClickChevronDown,
  disabled,
}) => {
  const btnClassName = disabled ? "cursor-not-allowed" : "cursor-pointer";
  const renderedDecoration = (() => {
    switch (type) {
      case "spinner":
        return <Spinner />;
      case "chevron-down":
        return (
          <Icon
            onClick={disabled ? undefined : onClickChevronDown}
            icon="chevron-up"
            className={clsx(btnClassName, "rotate-180 w-4 text-gray-600 cursor-pointer")}
          />
        );
      case "clear":
        return (
          <Icon
            icon="close"
            onClick={disabled ? undefined : onClickClear}
            className={clsx(btnClassName, "w-5 text-gray-600 cursor-pointer")}
          />
        );
      default:
        return (
          <Icon icon={type} onClick={onClickIcon} className="w-4 text-gray-600 cursor-pointer" />
        );
    }
  })();

  return (
    <div className="select-none w-full h-full flex items-center justify-center pr-3">
      {renderedDecoration}
    </div>
  );
};
